import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import "./DietPlanTemplateModal.css";

const DietPlanTemplateModal = ({ show, handleClose, handleSubmit }) => {
  const [title, setTitle] = useState("");
  const [templateContent, setTemplateContent] = useState("");
  const [errors, setErrors] = useState({});

  const closeModal = () => {
    handleClose();
    setTitle("");
    setTemplateContent("");
  };

  const validateForm = () => {
    const newErrors = {};

    if (!title.trim()) {
      newErrors.title = "Title is required";
    }
    if (!templateContent) {
      newErrors.content = "Content is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = () => {
    if (validateForm()) {
      const payload = {
        title,
        content: templateContent,
      };
      handleSubmit(payload);
    }
  };

  return (
    <Modal show={show} onHide={closeModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create Diet Plan Template</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="title">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              isInvalid={!!errors.title}
            />
            <Form.Control.Feedback type="invalid">
              {errors.title}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId='textContent'>
            <Form.Label>Template Content</Form.Label>
            <Form.Control as="textarea"
              type='text'
              rows={5}
              placeholder='Enter Template content'
              value={templateContent}
              onChange={(e) => setTemplateContent(e.target.value)}
            />
            <div className="text-danger">
              {errors.content}
            </div>
          </Form.Group>

        </Form>
      </Modal.Body>
      <Modal.Footer className="flex-column">
        <Button variant="secondary" onClick={closeModal}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSubmit}>
          Create
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DietPlanTemplateModal;
